import { createCustomerOrgUnitScope } from '@/helpers/queryKeyScopes'

// Single source of truth for quantity normalization. The price key's quantity dimension and the
// loader's dedup key must agree, so every call site building a key normalizes quantity through this.
export const normalizeQuantity = (quantity?: number): number => quantity || 1

export interface PriceKeyScope {
  customerId: string
  orgUnitId: string
  baseSiteId: string
  productId: string
  quantity: number
}

const scope = createCustomerOrgUnitScope('getPrices')

export const getPricesKeys = {
  ...scope,
  // One cache entry per product+quantity (scoped to customer, organisation and site). Each product is
  // fetched and cached independently, so adding products never refetches existing ones and a quantity
  // change refetches only that product. Many components fetching the same key share a single request.
  product: ({ customerId, orgUnitId, baseSiteId, productId, quantity }: PriceKeyScope) => {
    return [...scope.orgUnit(customerId, orgUnitId), 'product', baseSiteId, productId, quantity] as const
  },
} as const
